import { useTranslation } from "react-i18next";
import NavBar from "../components/NavBar";
import { Link } from "react-router-dom";
import { trackCTA } from "../utils/eventTracker";
import BackgroundImage from "../components/BackgroundImage";
import Footer from "../components/Footer";

export default function Imcorp() {
  const { t } = useTranslation();
  return (
    <div className="page-wrapper">      
      <BackgroundImage />
      <NavBar />
      <div className="transparency-wrapper">
        <div className="big-title">IMCORP</div>
        <img
          src="/projects/imcorp.webp"
          alt="IMCORP"
          className="project-image"
        />
        <div className="porfolio-project-text-wrapper">
          <p className="section-content-unbounded">
            {t("imcorpDescriptionShort")}{" "}
            {t("imcorpLinkLabel")}{" "}
            <a
              href="https://imcorp.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="project-link"
            >
              {t("imcorpLinkText")}↗
            </a>
          </p>
          <p className="section-content-unbounded">
            {t("imcorpDescriptionLong")}
          </p>       
        </div>
        <div className="cta-button-secondary-wrapper-bottom">
          <Link 
            to="/quote"
            className="cta-button-secondary"
            onClick={() => trackCTA("imcorpPage")}
          >
            {t("ctaBookCall")}
          </Link>
        </div>
        <Footer /> 
      </div>
    </div>
  );
}
